// extracted by mini-css-extract-plugin
export default {"toggle":"ViewModeToggle_toggle__S9Hgv","option":"ViewModeToggle_option__RveJ3","optionActive":"ViewModeToggle_optionActive__1+n-U"};